export const API_BASE_URLS = {
  MAIN: 'http://localhost:3001/api',
  MOCK: 'http://127.0.0.1:3658/m1/805700-784501-default',
  LOGOUT: 'https://mock.apidog.com/m1/805700-784501-default'
};

export const PRODUCT_API_BASE_URL = {
  MAIN: 'http://localhost:3001/api',
  MOCK: 'http://127.0.0.1:3658/m1/805700-784501-default',
  LOGOUT: 'https://mock.apidog.com/m1/805700-784501-default'
};

export const BASE_URLS = {
  MAIN: 'http://tykven.local/v2',
};